export default __webpack_public_path__ + "static/media/ico-thumbnail-white.732725e5.svg";